import config from 'config';

const isMentorNetwork = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return [259, 260];
    case 'beta':
      return [452, 453, 454, 455, 456, 457, 66, 624];
    case 'production':
      return [452, 453, 454, 455, 456, 457, 66, 624];
    default:
      return [];
  }
};

const isMentorMasterNetwork = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return [246, 274];
    case 'beta':
      return [451, 471, 622, 623];
    case 'production':
      return [451, 471, 622, 623, 2317, 2315, 2318, 2316];
    default:
      return [];
  }
};

const isKrisementorNetwork = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return [274];
    case 'beta':
      return [471, 623];
    case 'production':
      return [471, 623];
    default:
      return [];
  }
};

const communityIsConnectedToDnb = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return [
        442, // TNT NXT
      ];
    case 'beta':
      return [
        2867, // DNB NXT 2022
        1788, // DNB NXT Demo community
        1128, // DNB NXT Healthcare Venture Session
        2472, // DNB NXT Healthcare Venture Session 2021
      ];
    case 'production':
      return [
        2867, // DNB NXT 2022
        1788, // DNB NXT Demo community
        1128, // DNB NXT Healthcare Venture Session
        2472, // DNB NXT Healthcare Venture Session 2021
      ];
    default:
      return [];
  }
};

const communityIsConnectedToSeb = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return ['seb-test-community'];
    case 'beta':
    case 'production':
      return ['seb-nordic-family-office-summit'];
    default:
      return [];
  }
};

const organizationMapping = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return {
        SEB: 'org_MHDBmArqLomajzRI',
      };
    case 'beta':
    case 'production':
      return { SEB: 'org_ghaojuKAKSnDP4B3' };
    default:
      return { SEB: undefined };
  }
};

export const arenaCommunitiesOnDiscover = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'beta':
    case 'production':
      return {
        nxt: 'dnb-nxt-arena',
        health: 'health-arena',
        green: 'green-arena',
        fintech: 'fintech-arena',
      };
    case 'test':
    default:
      return {
        nxt: 'tnt-nxt',
        health: 'acne-inc',
        green: '420-arena',
        fintech: 'test-fintech-arena',
      };
  }
};

const communityMustAcceptMCTerms = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return ['skotn-community', 'founder-as-investors'];
    case 'beta':
    case 'production':
      return ['mastercard-fintech-forum-2025-munich'];
    default:
      return [];
  }
};

const isMastercardEvent = () => {
  switch (config.BUILD_ENVIRONMENT.toLowerCase()) {
    case 'test':
      return [{ id: 'a658158e-0192-4c28-965c-a0611bb08d8e', hasAgenda: true }, {}];
    case 'beta':
    case 'production':
      return [
        { id: '186e6ccf-6e42-48db-8acc-72268609a7b8', hasAgenda: true },
        {
          id: 'a75efc47-851c-47c5-9f4b-0acdf89569f2',
          hasAgenda: false,
        },
        { id: '5eca4d19-0e13-444f-998f-cb261c720dc9', hasAgenda: true },
      ];
    default:
      return [];
  }
};

export default {
  isMentorMasterNetwork: (communityId?: number) => isMentorMasterNetwork().some(a => a === communityId),
  isMentorCommunity: (communityId?: number) =>
    isMentorNetwork().some(a => a === communityId) || isMentorMasterNetwork().some(a => a === communityId),
  isKrisementorNetwork: (communityId?: number) => isKrisementorNetwork().some(a => a === communityId),
  communityIsConnectedToDnb: (communityId?: number) => communityIsConnectedToDnb().some(a => a === communityId),
  communityIsConnectedToSeb: (communitySlug?: string) => communityIsConnectedToSeb().some(a => a === communitySlug),
  communityMustAcceptMCTerms: (communitySlug?: string) => communityMustAcceptMCTerms().some(a => a === communitySlug),
  mastercardEventToggle: (eventId: string) => isMastercardEvent().find(a => a.id === eventId.toLowerCase()),
  organizationMapping: organizationMapping,
};
